import { getGTZHochrechnung } from './getGTZHochrechnung';
import { IDs } from '../../../helpers/IDs';
import * as Moment from 'moment';

export function getHochrechnung(valuesGtz: any[], standort: any, energietraeger_tid: number, einheit_tid: number,
    data: any, values: any, jahr: number, cb?: (berechnungData: any) => void) {
    // console.log('valsGtz', valuesGtz);
    // GTZ-Hochrechnung)
    const gtz_hochrechnung = getGTZHochrechnung(valuesGtz);
    // GTZ für Abrechnungszeitraum
    const az_von = values.abrechnungszeitraum_von;
    const az_bis = values.abrechnungszeitraum_bis;
    const az_days = +Moment(az_bis * 1000).diff(Moment(az_von * 1000), 'd') + 1;
    // console.log('Tage im AZ: ', az_days);
    const gtz_az = getGTZinRange(az_von, az_bis, gtz_hochrechnung);
    const gtz_day_base = gtz_az.sumGTZ / az_days;
    // Verbräuche Rechnungen
    const verbrauch_rechnungen = getVerbrauchAusRechnungen(standort, energietraeger_tid, einheit_tid,
        data, gtz_hochrechnung, gtz_day_base, jahr);
    // console.log('getHochrechnung VERBR:', energietraeger_tid, einheit_tid, verbrauch_rechnungen);
    let sumGTZ = 0;
    let sumVerbrauch = 0;
    let sumDays = 0;
    let preis_datum: number = undefined;
    let preis: number = undefined;
    verbrauch_rechnungen.forEach((vb: any) => {
        sumVerbrauch += vb.verbrauch;
        sumGTZ += vb.sumGTZ;
        sumDays += vb.days;
        if (!preis_datum || vb.datum_von > preis_datum) {
            preis_datum = vb.datum_von;
            preis = Math.round(vb.preis * 100) / 100;
        }
    });
    const verbrauch_pro_GTZ = sumVerbrauch / sumGTZ;
    const az_gtz = gtz_az.sumGTZ;
    const verbrauch_prognose = Math.round(verbrauch_pro_GTZ * az_gtz);
    const berechnungData = {
        gtz_hochrechnung, verbrauch_rechnungen, az_von, az_bis, az_days, az_gtz,
        sumDays, sumGTZ, sumVerbrauch, verbrauch_prognose, preis
    };
    if (cb) {
        cb(berechnungData);
    }
    return berechnungData;
}

function getVerbrauchAusRechnungen(standort: any, energietraeger_tid: number, einheit_tid: number,
    data: any, gtz_hochrechnung: any, gtz_day_base: number, jahr: number): any[] {
    const rechnungen = data[IDs.ENT_OEL_ABRECHNUNG];
    // console.log('Filter', rechnungen, standort, energietraeger_tid, einheit_tid);
    const prepared = rechnungen.filter((rg: any) => rg.standort_tid_orig === standort.tid &&
        rg.einheit_tid_orig === einheit_tid &&
        rg.energietraeger_tid_orig === energietraeger_tid)
        .sort((a: any, b: any) => a.datum_befuellung - b.datum_befuellung);
    // console.log('Filtered: ', prepared);
    const verbrauch: any[] = [];
    let lastStamp: number = undefined;
    const maxVon = Moment(jahr + '-12-31', 'YYYY-MM-DD').unix();
    prepared.forEach((item: any, idx: number) => {
        if (lastStamp && lastStamp < maxVon) {
            const gtzInRange = getGTZinRange(lastStamp, item.datum_befuellung, gtz_hochrechnung);
            const vb = {
                datum_von: lastStamp,
                datum_bis: item.datum_befuellung,
                verbrauch: item.fuellmenge,
                kosten: item.kosten,
                preis: item.kosten / item.fuellmenge,
                gtz_faktor: gtz_day_base / gtzInRange.gtz_day,
                ...gtzInRange
            };
            verbrauch.push(vb);
        } else {
            // console.log('getHochrechnung ignoring: ', lastStamp, maxVon, idx);
        }
        lastStamp = item.datum_befuellung;
    });
    // console.log('Preped: ',  prepared);
    return verbrauch;
}

const lastAvailable: any = {};

export function getGTZforJahr(jahr: number, gtz_hochrechnung: any) {
    const start = new Date('1/1/' + jahr);
    const end = new Date('12/31/' + jahr);
    // console.log('getGTZinRange calle by getGTZforJahr', jahr);
    return getGTZinRange(start.getTime() / 1000, end.getTime() / 1000, gtz_hochrechnung);
}

export function getGTZinRange(from: number, to: number, gtz_hochrechnung: any) {
    const mFrom = Moment(from * 1000);
    const mTo = Moment(to * 1000).add(1, 'd');
    const days = +mTo.diff(mFrom, 'd');
    // console.log('getGTZinRange', mFrom.format('YYYY-MM-DD'), mTo.format('YYYY-MM-DD'));
    const yearFrom = +mFrom.format('YYYY');
    const yearTo = +mTo.format('YYYY');
    let sumGTZ = 0;
    let sumMittel = 0; // GTZ -> Langjähriges Mittel
    for (let jahr = yearFrom; jahr <= yearTo; jahr++) {
        for (let mon = 1; mon <= 12; mon++) {
            const mon_start = Moment(jahr + '-' + mon + '-01', 'YYYY-MM-DD').startOf('month');
            const mon_end = Moment(jahr + '-' + mon + '-01', 'YYYY-MM-DD').endOf('month');
            const fullIn = mon_start.isAfter(mFrom) && mon_end.isSameOrBefore(mTo);
            const beginsIn = mon_start.isSameOrBefore(mFrom) && mon_end.isSameOrAfter(mFrom);
            const endsIn = mon_start.isSameOrBefore(mTo) && mon_end.isSameOrAfter(mTo);
            // console.log('GTZ for', jahr, mon);
            let jahrUse = jahr;
            if (gtz_hochrechnung[jahr] && gtz_hochrechnung[jahr][mon]
                && (gtz_hochrechnung[jahr][mon].gtz || gtz_hochrechnung[jahr][mon].gtz === 0)) {
                if (jahr > lastAvailable[jahr]) {
                    lastAvailable[mon] = jahr;
                }
            } else {
                jahrUse = lastAvailable[mon];
                // console.log('getGTZinRange USING ' + jahrUse + ' for ' + mon + '/' + jahr, gtz_hochrechnung);
            }
            if (!jahrUse) {
                // console.log('getGTZinRange NOTHING for ', jahr, mon);
                continue;
            }
            if (fullIn) {
                sumGTZ += gtz_hochrechnung[jahrUse][mon].gtz;
                // GTZ -> Langjähriges Mittel
                sumMittel += gtz_hochrechnung[jahrUse][mon].mittel_10_jahre > 0 ? gtz_hochrechnung[jahrUse][mon].mittel_10_jahre : 0;
                // console.log('GTZ Ganzer Monat: '  + mon + '.' + jahrUse + ' = ' + gtz_hochrechnung[jahrUse][mon].gtz);
            } else if (beginsIn) {
                const diff_days = +mon_end.diff(mFrom, 'd') + 1;
                const gtz = diff_days * gtz_hochrechnung[jahrUse][mon].gtz_day;
                // GTZ -> Langjähriges Mittel
                const mittel = diff_days * gtz_hochrechnung[jahrUse][mon].mittel_day;
                // console.log('Starts', diff_days, gtz_hochrechnung[jahrUse][mon].gtz_day);
                // console.log('GTZ 1. Monat: '  + mon + '.' + jahrUse + ' (' + diff_days + ' Tage) = ' + gtz_hochrechnung[jahrUse][mon].gtz_day + ' * ' + diff_days + ' = ' + gtz);
                sumGTZ += gtz;
                sumMittel += mittel;
            } else if (endsIn) {
                const diff_days = +mTo.diff(mon_start, 'd');
                const gtz = diff_days * gtz_hochrechnung[jahrUse][mon].gtz_day;
                // GTZ -> Langjähriges Mittel
                const mittel = diff_days * gtz_hochrechnung[jahrUse][mon].mittel_day;
                sumGTZ += gtz;
                sumMittel += mittel;
                // console.log('GTZ Letzter Monat: '  + mon + '.' + jahrUse + ' (' + diff_days + ' Tage) = ' +
                //                gtz_hochrechnung[jahrUse][mon].gtz_day + ' * ' + diff_days + ' = ' + gtz);
                // console.log('Ends', diff_days, gtz_hochrechnung[jahrUse][mon].gtz_day);
            }
            // console.log('getGTZinRange', jahr, mon, mon_start.format('YYYY-MM-DD'), mon_end.format('YYYY-MM-DD'), fullIn, beginsIn, endsIn, sumGTZ);
        }
    }
    // console.log('GTZ Summe: ' + sumGTZ);
    // console.log(gtz_hochrechnung);

    // sumGTZ = Math.round(sumGTZ);
    const gtz_day = sumGTZ / days;
    return { sumGTZ, sumMittel, days, gtz_day };
}
